import { type FloorGameActivity } from '@pkg/types/floorGame';

export enum FloorGameTicksMeterSize {
    Compact = 'compact',
    Normal = 'normal',
    Extended = 'extended',
}

export interface FloorGameTicksOptions {
    size: FloorGameTicksMeterSize;
    // TODO: Still not sure how `activity` is determined.
    activity?: FloorGameActivity;
    totalListingsInTier?: number;
}
